// src/state/index.ts
var State = {
  get: (key) => {
    if (window.yvaDatastore?.state) {
      return window.yvaDatastore.state[key];
    }
  },
  set: (key, value) => {
    if (window.yvaDatastore?.state) {
      window.yvaDatastore.state[key] = value;
    }
  }
};

export {
  State
};
